import { Route, Routes, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import {
  ViewConfigurationClientProvider,
  ViewLoader,
} from "@rumbledirect/view-config";
import { CalculationUpload } from "./components/calculation/calculation-upload";
import { Wrapper } from "./components/wrapper";
import { axiosInstance } from "./lib/queries/client";

function App() {
  const [searchParams] = useSearchParams();
  const dossierId = searchParams.get("dossierId") || "";
  const affiliateId = searchParams.get("affiliateId") || "";

  useEffect(() => {
    localStorage.setItem("affiliateId", affiliateId);
  }, [affiliateId]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Wrapper>
            <ViewConfigurationClientProvider
              axiosInstance={axiosInstance}
              affiliateId={affiliateId}
            >
              <ViewLoader dossierId={dossierId} actorPrefix="dealership" />
            </ViewConfigurationClientProvider>
          </Wrapper>
        }
      />
      <Route
        path="/calculation-upload"
        element={
          <Wrapper>
            <CalculationUpload dossierId={dossierId} />
          </Wrapper>
        }
      />
    </Routes>
  );
}

export default App;
